<template>
  <div>
    <slick
      ref="textTestimonialSlider"
      :options="textTestimonialSlider"
      class="stu-card-slider green-slick-dots"
    >
      <div v-for="(data, index) in testimonialsData" :key="index">
        <div class="stu-card px-xl-4 py-xl-4 px-3 py-3 my-3">
          <div class="stu-img">
            <img
              :src="require('@/assets/imgs/testimonial/' + data.img)"
              class="img-fluid"
            />

            <div class="stu-details" v-if="design != 'design-2'">
              <div class="title text-truncate">{{ data.name }}</div>
              <div class="content-label">{{ data.role }}</div>
            </div>
          </div>
          <div class="stu-content pt-2 pt-lg-0">
            <div>
              <!-- <img src="@/assets/imgs/quote.svg" class="img-fluid" /> -->
              <!-- <read-more
                class="text-content pl-xl-4 text-left"
                :text="data.content"
                less-str="read less"
                :max-chars="300"
              ></read-more> -->
              <div class="pl-xl-4">
                <p class="text-content text-left" v-if="design !== 'design-2'">
                  {{ data.content }}
                </p>
                <p class="text-content-2 text-left" v-if="design == 'design-2'">
                  {{ data.content }}
                </p>
                <!-- <span class="read-more-text" v-b-modal="'show-content' + index">
                  Read More</span
                > -->

                <div>
                  <b-modal
                    :id="'show-content' + index"
                    centered
                    :title="data.name"
                    :hide-footer="true"
                  >
                    <p>{{ data.content }}</p>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="pt-2" v-if="design == 'design-2'">
              <div class="d-flex">
                <div class="pr-3 pt-2 mt-1">
                  <img src="@/assets/imgs/blue-line.svg" class="img-fluid" />
                </div>
                <div>
                  <p class="title">{{ data.name }}</p>
                  <p class="sm-content">{{ data.role }}</p>
                </div>
              </div>
              <!-- <img src="@/assets/imgs/stu-card-2.png" class="img-fluid" /> -->
            </div>
          </div>
        </div>
      </div>
    </slick>
  </div>
</template>

<script>
  import { BModal } from "bootstrap-vue";
  // import Calendly from "vue-calendly";
  // import "https://assets.calendly.com/assets/external/widget.js"

  export default {
    name: "TextTestimonialSlider",
    components: {
      BModal,
    },
    data() {
      return {
        textTestimonialSlider: {
          infinite: true,
          slidesToShow: 2.5,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          // autoplay: true,
          // autoplaySpeed: 0,
          // speed: 5000,
          // cssEase: "linear",
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
              },
            },
          ],
        },
      };
    },

    props: {
      testimonialsData: {
        type: Array,
        default: "",
      },
      design: {
        type: String,
        default: "design-1",
      },
    },

    methods: {},
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/TextTestimonialSlider.vue